export enum EPath {
  Root = '/',
  /** 登录页 */
  Login = '/login',
  Register = '/register',
  Logout = '/logout',
  /** 入口页 */
  Portal = '/portal',
  /** 编辑器 */
  Editor = '/editor',
  /** 用户信息页 */
  Account = '/account',
  /** 方案列表页 */
  Workbench = '/workbench',
  /** 概算统计页 */
  Summary = '/summary',
  /** 新版概算集计页，开发完成后替代 Summary */
  Estimate = '/estimate',
  /** 开发相关功能页 */
  Development = 'development',
  /** 管理后台路径前缀 */
  Admin = '/admin',
  /** 团队管理页 */
  AdminTeam = '/admin/team',
  /** 概算单价管理页：项目单价、什器部品价格与免责声明 */
  AdminEstimate = '/admin/estimate',
  /** 分享页面 */
  Share = '/share'
}
